<!--首页底部信息-->
<template>
  <div class="footer-container">
    <div class="div-1">
      <p>
        <el-link class="el-active" :underline="false" @click="aboutUs">关于我们</el-link>
        <el-link class="el-active" :underline="false" style="margin-left: 40px" @click="serviceAgreement">服务协议</el-link>
      </p>
      <p>
        <el-link class="el-active" :underline="false" @click="merchantCenter">商家中心</el-link>
        <el-link class="el-active" :underline="false" style="margin-left: 40px" @click="privacyPolicy">隐私政策</el-link>
      </p>
      <p v-if="CustomInfo.status!=1">
        <el-link class="el-active" :underline="false" @click="enterpriseCertification">企业认证</el-link>
      </p>
      <p>
        <el-link class="el-active" :underline="false" @click="businessCooperation">商务合作</el-link>
      </p>
      <div class="qr-codes">
        <div class="qr">
          <div class="qr-code">
            <div class="android-logo"></div>
          </div>
          <p style="font-size: 12px;">Android</p>
        </div>
        <div class="qr">
          <div class="qr-code">
            <div class="ios-logo"></div>
          </div>
          <p style="font-size: 12px;">iOS</p>
        </div>
        <div class="qr">
          <div class="qr-code">
            <div class="applet-logo"></div>
          </div>
          <p style="font-size: 12px;">小程序</p>
        </div>
      </div>
    </div>
    <el-divider/>
    <div class="div-2">
      <p class="el-describe">
        <el-link type="info" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=11000002000100"
                 :underline="false" class="link-info">渝公网安备&nbsp;11000002000100号
        </el-link>&emsp;
        <el-link type="info" href="http://beian.miit.gov.cn" :underline="false" class="link-info">{{identification.type}}
        </el-link>
        Copyright&nbsp;©&nbsp;2004&nbsp;-&nbsp;2021&emsp;{{ identification.name }}&nbsp;版权所有
      </p>
    </div>
    <vxe-modal v-model="dialog1" width="600" :showHeader="false" transfer mask-closable show-close>
      <template #default>
        <div class="dialog">
          <vxe-button type="text" icon="fa vxe-icon--close" class="close-btn" title="关闭" @click="dialog1=false"/>
          <about-us/>
        </div>
      </template>
    </vxe-modal>
  </div>
</template>

<script>
import Vue from 'vue';
import AboutUs from "@/views/personal/aboutUs";
import VXETable from 'vxe-table';
import 'vxe-table/lib/index.css';
import {personal} from '@/api/interfaceApi'
import cityJson from "@/static/cityJson.json";
Vue.use(VXETable)
export default {
  name: "home_footer",
  components: {AboutUs},
  data(){
    return{
      dialog1:false,
      CustomInfo:{},
      cityList:{},
      identification:{type:'渝ICP备1541704号',name:'重庆帮企科技集团有限公司'},
    }
  },
  mounted() {
    this.GetQueryString();
  },
  methods:{
    /*关于我们*/
    aboutUs(){
      this.dialog1=true;
    },
    /*服务协议*/
    serviceAgreement(){
      window.open('https://customerservice.bangqichat.com/index/agreement/article?aWQ9MjE=', '_blank')
    },
    /*商家中心*/
    merchantCenter(){
      let that=this;
      if (JSON.stringify(that.CustomInfo)=='{}'){
        that.$alert('您还没有登录,是否进行登录', {
          confirmButtonText: '确定',
          callback: action => {
            that.$router.replace({
              path: '/login'
            })
          }
        })
      }else{
        personal({
          bid:that.CustomInfo.cid,
          cid:that.CustomInfo.cid
        }).then(res=>{
          if (res.code==200){
            if (res.content.shopId==0 || res.content.shopId==null || res.content.shopId==undefined){
              that.$alert('您的账号未开通店铺，请先认证企业再开通店铺', '提示', {
                confirmButtonText: '确定',
                callback: action => {
                  let routeData = that.$router.resolve({
                    name: "enterpriseCertification",
                    path: '/officialCloud/enterpriseCertification',
                  });
                  window.open(routeData.href, '_blank')
                }
              });
            }
          }else{
            /*跳转店铺详情*/
            let routeData = that.$router.resolve({
              name: "shop",
              path: '/storeManagement/shop',
              query: {
                id: res.content.shopId,
                pName: that.cityList.abridge + '企服务云'
              }
            });
            window.open(routeData.href, '_blank')
          }
        })
      }
    },
    /*隐私政策*/
    privacyPolicy(){
      window.open('https://customerservice.bangqichat.com/index/agreement/article?aWQ9MjA=', '_blank')
    },
    /*企业认证*/
    enterpriseCertification(){
      if (JSON.stringify(this.CustomInfo)=='{}'){
        this.$alert('您还没有登录,是否进行登录', {
          confirmButtonText: '确定',
          callback: action => {
            this.$router.replace({
              path: '/login'
            })
          }
        })
      }else {
        let routeData = this.$router.resolve({
          name: "enterpriseCertification",
          path: '/officialCloud/enterpriseCertification',
        });
        window.open(routeData.href, '_blank')
      }
    },
    /*商务合作*/
    businessCooperation(){
      let routeData = this.$router.resolve({
        name: "businessCooperation",
        path: '/businessCooperation/index',
      });
      window.open(routeData.href, '_blank')
    },
    /*比对域名*/
    GetQueryString(){
      //获取页面完整地址
      let url = window.location.href;
      if (url.indexOf('smegov.cn')>-1){
        this.identification.type='京ICP备2021003286号-1';
        this.identification.name='北京帮企科技集团有限公司';
      }else if (url.indexOf('smegov.net')>-1){
        this.identification.type='京ICP备2021003286号-2';
        this.identification.name='北京帮企科技集团有限公司';
      }else if (url.indexOf('bangqichat.cn')>-1){
        this.identification={type:'渝ICP备2022008948号-1',name:'帮企网重庆科技有限公司'};
      }else{
        this.identification={type:'渝ICP备18009567号-4',name:'重庆帮企科技集团有限公司'};
      }
      console.log(url)
    }
  },
  beforeMount() {
    this.CustomInfo=sessionStorage.getItem('CustomInfo') ? sessionStorage.getItem('CustomInfo') : {};
    if (sessionStorage.getItem('setPositioning'))
      this.cityList = JSON.parse(sessionStorage.getItem('setPositioning'));
    else if (sessionStorage.getItem('locationInfo')){
      let cityList = JSON.parse(sessionStorage.getItem('locationInfo'));
      for (let li of cityJson) {
        if (cityList.short_name == li.short_name)
          this.cityList = li;
      }
    }
  }
}
</script>
<style scoped>
.footer-container >>> .el-divider--horizontal {
  display: block;
  height: 1px;
  width: 51%;
  margin: 20px 23%;
  background: #43484D;
}
</style>
<style scoped lang="scss">
.footer-container {
  background: #2d3237;
  padding: 20px 18% 10px;
  min-width: 76rem;
  .div-1 {
    .qr-codes{
      display: flex;
      width: 350px;
      justify-content: space-between;
      text-align: center;
      margin-top: -120px;
      float: right;
      .qr{
        .qr-code{
          background: #fff;
          border: 1px solid #fff;
          margin-bottom: 5px;
          border-radius: 8px;
          .android-logo{
            width: 90px;
            border-radius: 8px;
            height: 90px;
            background: url("~@/assets/img/android.png") no-repeat;
            background-size: 100% 100%;
          }
          .ios-logo{
            width: 90px;
            height: 90px;
            border-radius: 8px;
            background: url("~@/assets/img/ios.png") no-repeat;
            background-size: 100% 100%;
          }
          .applet-logo{
            width: 90px;
            height: 90px;
            border-radius: 8px;
            background: url("~@/assets/img/applet.png") no-repeat;
            background-size: 100% 100%;
          }
        }
      }
    }
    p {
      margin-block-start: 0em;
      margin-block-end: 10px;
      color: #ffffff;
      font-size: 14px;
      .el-active {
        color: white;
        font-size: 14px;
      }
    }
  }
  .div-2 {
    color: #BFBFBF;
    font-size: 12px;
    text-align: center;
    .link-info {
      color: #BFBFBF;
      font-size: 12px;
      vertical-align: baseline;
    }
  }
}
</style>